import { FOURTEEN_DAYS_MS } from 'shared/constants/time';
import { ReportInfo } from 'store/api/apiTypes';

/**
 * Calculate the number of trial days remaining based on the last report date.
 * Uses midnight-based comparison (ignoring hours/minutes).
 * @returns Remaining whole days clamped to 0..14, or null if the report date is missing/invalid.
 */
export const getTrialDaysLeft = (
  lastReport: ReportInfo | undefined
): number | null => {
  if (!lastReport?.date) return null;

  const reportDateObj = new Date(lastReport.date);
  const reportDateMs = reportDateObj.getTime();

  if (Number.isNaN(reportDateMs)) return null;

  const reportMidnight = new Date(
    reportDateObj.getFullYear(),
    reportDateObj.getMonth(),
    reportDateObj.getDate()
  ).getTime();

  const today = new Date();
  const todayMidnight = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  ).getTime();

  const trialEndMidnight = reportMidnight + FOURTEEN_DAYS_MS;
  const diffMs = trialEndMidnight - todayMidnight;

  return Math.max(0, Math.min(14, Math.round(diffMs / 86400000)));
};
